import { ResourceBaseService } from "@/core/common/resource-base/resource-base.service";
import { SupplierInvoiceDto } from "./supplier-invoice.dto";
import { CreateSupplierInvoiceDto } from "./create-supplier-invoice.dto";
import { UpdateSupplierInvoiceDto } from "./update-supplier-invoice.dto";
import { ChangeSupplierInvoiceStatusDto } from "./change-supplier-invoice-status.dto";
import { ApiHttpClient } from "@/core/common/http/api-http-client";
import { HttpRequest } from "@/core/common/http/http-request";
import { SupplierInvoiceStatusEnum } from "@altertec_gparn/lib";
import { plainToInstance } from "class-transformer";

export class SupplierInvoicesResource extends ResourceBaseService<
  SupplierInvoiceDto,
  CreateSupplierInvoiceDto,
  UpdateSupplierInvoiceDto
> {
  protected EntityDto = SupplierInvoiceDto;
  protected CreateEntityDto = CreateSupplierInvoiceDto;
  protected UpdateEntityDto = UpdateSupplierInvoiceDto;

  constructor(protected readonly apiHttpClient: ApiHttpClient) {
    super(apiHttpClient, "/supplier-invoices");
  }

  async createWithFile(formData: FormData): Promise<SupplierInvoiceDto> {
    return this.apiHttpClient.request<FormData, SupplierInvoiceDto>(
      HttpRequest.create<FormData>({
        url: this.resourceUrl + "/upload",
        method: "POST",
        auth: true,
        body: formData,
        type: "form-data",
      })
    );
  }

  changeStatus(id: string, status: SupplierInvoiceStatusEnum): Promise<SupplierInvoiceDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/change-status",
        method: "PATCH",
        auth: true,
        body: plainToInstance(ChangeSupplierInvoiceStatusDto, { status: status, id: id }),
      })
    );
  }

  setAssignee(id: string, assigneeId: string): Promise<SupplierInvoiceDto> {
    return this.apiHttpClient.request(
      HttpRequest.create({
        url: this.resourceUrl + "/" + id + "/set-assignee",
        method: "PATCH",
        auth: true,
        body: { supplierInvoiceId: id, assigneeId: assigneeId },
      })
    );
  }
}
